export * from './informations';
export * from './inscription';
export * from './landing';
export * from './succes';
